import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Edit } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ContactInfo } from "./contacts/ContactInfo";
import { LinkedJobs } from "./contacts/LinkedJobs";
import { Contact } from "./contacts/types";
import { useTranslation } from "react-i18next";

interface ContactViewModalProps {
  isOpen: boolean;
  onClose: () => void;
  contact: Contact | null;
  onEdit: (contact: Contact) => void;
  companyId: string;
}

export const ContactViewModal = ({
  isOpen,
  onClose,
  contact,
  onEdit,
  companyId
}: ContactViewModalProps) => {
  const { t } = useTranslation();
  if (!contact) return null;
  
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>{t("contacts.details")}</DialogTitle>
        </DialogHeader>
        
        <div className="mt-4 space-y-6">
          <ContactInfo contact={contact} />
          
          <LinkedJobs 
            contactId={contact.id} 
            companyId={companyId} 
          />
        </div>
        
        <div className="flex justify-end mt-6">
          <Button 
            variant="outline" 
            className="mr-2"
            onClick={onClose}
          >
            {t("contacts.close")}
          </Button>
          <Button 
            className="bg-digger-blue hover:bg-digger-blue-light"
            onClick={() => onEdit(contact)}
          >
            <Edit className="h-4 w-4 mr-2" />
            {t("contacts.editContact")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
